module.exports = __webpack_public_path__ + "static/disp-overlay-d59f387b945bb666f20bb30c0e78c509.jpg";